import React from 'react'

const SpinnerLoader = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
            <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
                <span className="visually-hidden">pageloading...</span>
            </div>
        </div>
    )
}

export default SpinnerLoader